import {
  Container,
  Paper,
  Title,
  Text,
  Stack,
  Group,
  Avatar,
  SimpleGrid,
} from '@mantine/core';
import { useAuthStore } from '../../stores/auth';
import { formatPhone } from '../../utils/formatPhone';

function InfoField({ label, value }: { label: string; value: string | null }) {
  return (
    <Stack gap={2}>
      <Text size="sm" c="dimmed" fw={500}>
        {label}
      </Text>
      <Text size="md">{value || '\u2014'}</Text>
    </Stack>
  );
}

export function ProfilePage() {
  const { user } = useAuthStore();

  const userInitials = user?.name?.split(' ').map(n => n[0]).join('') || 'U';
  const roleLabel = user?.role === 'admin' ? 'Administrator' : 'Team Member';

  return (
    <Container size="sm" py="md">
      <Title order={2} mb="lg">
        My Info
      </Title>

      <Paper withBorder p="xl" radius="md">
        <Group mb="xl">
          <Avatar size="lg" radius="xl" color="leicaRed">
            {userInitials}
          </Avatar>
          <Stack gap={2}>
            <Text size="lg" fw={600}>
              {user?.name}
            </Text>
            <Text size="sm" c="dimmed">
              {roleLabel}
            </Text>
          </Stack>
        </Group>

        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="lg">
          <InfoField label="Name" value={user?.name ?? null} />
          <InfoField label="Email" value={user?.email ?? null} />
          <InfoField label="Phone" value={formatPhone(user?.phone)} />
          <InfoField label="Role" value={roleLabel} />
        </SimpleGrid>
      </Paper>
    </Container>
  );
}
